import request from '@/axios'

// 获取日志列表
export function getLogList(params) {
  return request({
    url: '/lebo-system/web/captureLog/queryLogListByParam',
    method: 'get',
    params
  })
}
// 保存日志信息
export function saveCaptureLog(params) {
  return request({
    url: '/lebo-system/web/captureLog/saveCaptureLog',
    method: 'get',
    params
  })
}
// 更新日志信息
export function updateCaptureLog(params) {
  return request({
    url: '/lebo-system/web/captureLog/updateCaptureLog',
    method: 'get',
    params
  })
}

// 上传文件
export function uploadFile(params) {
  return request({
    url: '/lebo-system/web/captureLog/upload',
    method: 'post',
    data: params
  })
}

